import React, { useState } from "react";
import { Form, Space } from "antd";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import {
  Backdrop,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import axios, { AxiosError } from "axios";
import { SubmitButton } from "../../../component/SubmitButton";
import { enqueueSnackbar, VariantType } from "notistack";
import { axiosErrorMessages, Login } from "../../../API/api";
import { jwtDecode } from "jwt-decode";
import { getCookieToken } from "../../../Utils/utils";

type FormData = {
  Username?: string;
  Password?: string;
};

const LoginPage: React.FC = () => {
  let token: string = "";
  const navigate = useNavigate();
  const validateMessages = {
    required: " Enter ${label}",
    types: {
      email: "Enter Valid Email ID",
    },
  };
  const [form] = Form.useForm();
  const [isSpinning, setIsSpinning] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleCookie = async () => {
    token = (await getCookieToken()) as string;
    if (token && token !== undefined) {
      localStorage.setItem("token", token as string);
      const decodedValue = jwtDecode(token as string);
      localStorage.setItem("Decoded", JSON.stringify(decodedValue));
    }
  };

  const onFinish = async ({ Username, Password }: any) => {
    const data = {
      username: Username,
      password: Password,
    };
    setIsSpinning(true);
    try {
      const response = await Login(data);
      if (response) {
        handleCookie();
      }
      setIsSpinning(false);
      navigate(`/software-dashboard`);
      if (!localStorage.getItem("token")) {
        const intervalId = setInterval(() => {
          handleCookie();
        }, 12 * 60 * 60 * 1000);
        return () => {
          clearInterval(intervalId);
        };
      }
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (
          axiosError.response?.status === 403 ||
          axiosError.response?.status === 401
        ) {
          errorMsg = "Enter a valid Email ID and Password";
        } else {
          errorMsg = axiosErrorMessages(axiosError);
        }
      } else {
        errorMsg = error.message;
      }
      const type: VariantType = "error";
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setIsSpinning(false);
    }
  };

  return (
    <>
      <div className="container-login">
        <div className="left-cnt">
          <div className="left-cnt">
            <div className="left-cnt-wrapper">
              <div className="left-image"></div>
              <h2 className="login-welcome-text">
                Welcome to{" "}
                <span className="red-text">IT Management Application</span>
              </h2>
              <p className="login-welcome-text-sub">
                There are many variations of passages of Lorem Ipsum available,
                but the majority have suffered alteration in some form, by
                injected humour
              </p>
            </div>
          </div>
        </div>
        <div className="right-cnt">
          <Form
            form={form}
            name="basic"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            style={{ display: "inline-blo ck" }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete="off"
            className="login-wrapp"
            validateMessages={validateMessages}
          >
            <div className="login-brand"></div>
            <Form.Item<FormData>
              validateStatus="error"
              name="Username"
              hasFeedback
              labelAlign="left" // Align label to the left
              rules={[{ required: true, type: "email" }]}
            >
              <TextField
                id="outlined-basic"
                label="Email ID"
                variant="outlined"
              />
            </Form.Item>

            <Form.Item<FormData>
              className="password-form-item"
              name="Password"
              rules={[{ required: true }]}
            >
              <TextField
                id="outlined-basic"
                label="Password"
                variant="outlined"
                type={showPassword ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Item>

            <Form.Item
              wrapperCol={{ span: 24 }}
              style={{ marginBottom: "18px !important" }}
            >
              <Space className="btn-width-100">
                <SubmitButton btnName={"Login"} form={form} />
              </Space>
            </Form.Item>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={isSpinning}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Form>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
